module.exports = __webpack_public_path__ + "img/AramHasan-Ryshi7aidar.7961afeb.jpg";